var onloadCallback = null;

(function (w, d) {
	onloadCallback = function () {
		grecaptcha.render('g-recaptcha', {
			sitekey: '6LdWSiYTAAAAAMuYxskR32vbdAa8qTk_qkPGLrF6',
			callback: removeCaptchaError
		});
	};
	const defaultConfig = {
		// class of the parent element where the error/success class is added
		classTo: 'input-wrapper',
		errorClass: 'is-danger',
		successClass: 'is-success',
		// class of the parent element where error text element is appended
		errorTextParent: 'input-wrapper',
		// type of element to create for the error text
		errorTextTag: 'div',
		// class of the error text element
		errorTextClass: 'help help_error'
	};

	const inputs = d.querySelectorAll('.js-floating');
	const captcha = d.querySelector('.js-captcha');
	const form = d.getElementById("contactForm");

	const textareaCounter = new Counter();
	const pristine = new Pristine(form, defaultConfig);
	const event = new Event('change');
	const formId = guid();

	form.addEventListener('submit', validator);

	for (let i = inputs.length - 1; i >= 0; i--) {
		inputs[i].onchange = inputEvent;
		inputs[i].onkeyup = fieldEvent;
	}

	function inputEvent(e) {
		const label = d.querySelector('[for="' + this.id + '"]');
		label.classList.toggle('label_focused', this.value !== '');

		if (this.classList.contains('js-textarea')) {
			this.classList.toggle('textarea_open', this.value !== '');
		}
	}

	function guid() {
		function s4() {
			return Math.floor((1 + Math.random()) * 0x10000)
				.toString(16)
				.substring(1);
		}

		if (localStorage.getItem('formId')) {
			return localStorage.getItem('formId');
		} else {
			const id = s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
			localStorage.setItem('formId', id);
			return id;
		}
	}

	function showCaptchaError(state) {
		captcha.classList.toggle('is-hidden', state);
	}

	function removeCaptchaError() {
		captcha.classList.add('is-hidden');
	}

	function getValues(captcha) {
		const formData = new FormData();
		formData.append('g-recaptcha-response', captcha);
		formData.append('form-id', formId);
		formData.append('landingDomain', 'anti.fraud.covery.ai');
		if (d.referrer !== "") formData.append('referrer', d.referrer);
		if (d.location.search !== "") formData.append('utm', d.location.search);
		for (let i = inputs.length - 1; i >= 0; i--) {
			if (inputs[i].value !== '') {
				formData.append(inputs[i].name, inputs[i].value);
			}
		}
		return formData;
	}

	function disableFields(state) {
		for (let i = inputs.length - 1; i >= 0; i--) {
			inputs[i].disabled = state;
		}
		grecaptcha.reset();
	}

	function clearFields() {
		for (let i = inputs.length - 1; i >= 0; i--) {
			inputs[i].value = '';
			inputs[i].dispatchEvent(event);
		}
	}

	function fetchStatusHandler(response) {
		if (response.status === 200) {
			return response;
		} else {
			throw new Error(response.headers['Error-message'] || response.statusText);
		}
	}

	function showSuccessMessage() {
		swal({
			title: "Thanks for reaching out!",
			text: "Our sales representative will reply shortly!",
			type: "success",
			confirmButtonColor: "#b0b0b0",
			confirmButtonText: "Close",
			closeOnConfirm: true,
			animation: "slide-from-top",
		});
	}

	function sendAnalyticEvent() {
		if (ga) { ga('send', 'event', 'formsend', 'formsendLP', 'LPCoveryFormSend'); }
	}

	function send(captcha) {
		const url = w.location.origin + '/contact';

		fetch(url, {
			method: 'POST',
			body: getValues(captcha),
		})
			.then(fetchStatusHandler)
			.then(function () {
				disableFields(false);
				clearFields();
				showSuccessMessage();
				sendAnalyticEvent();
			})
			.catch(function (error) {
				disableFields(false);
				swal('Error!', error, 'error');
			});
	}

	function validator(e) {
		e.preventDefault();
		const isValidField = pristine.validate();
		const response = grecaptcha.getResponse();
		const isValidCaptcha = response.length > 0;

		showCaptchaError(isValidCaptcha);

		if (isValidField && isValidCaptcha) {
			disableFields(true);
			send(response);
		}
	}

	function fieldEvent(e) {
		e.preventDefault();
		if (this.value.match(/^[ ]+$/)) {
			this.value = '';
		}
		if (e.type === 'keyup' && e.target.tagName === 'TEXTAREA') {
			textareaCounter.add(this.parentNode);
			textareaCounter.update(this.value.length);
		}
	}

	function Counter() {
		this.counter = d.createElement('span');
		this.counter.className = 'help help_counter';
		this.firstAction = true;
	}

	Counter.prototype.add = function add(parent) {
		if (this.firstAction) {
			parent.appendChild(this.counter);
			this.firstAction = false;
		}
	};

	Counter.prototype.update = function update(count) {
		this.counter.innerHTML = (500 - count) + "/500";
	};
})(window, document);
